import React from "react";
import CalculatorRow from "../CalculatorRow";
import { useTranslation } from "react-i18next";
import ZipCode  from "src/components/CustomizePayment/ZipCode/index";
import useSelector from "src/utils/useSelector";

const ZipCodeRow = () => {
    const isZipCodeUS = useSelector((state) =>  state.account?.address?.country === "US");
    const globalZipFromAccountDisclaimer= useSelector((state) =>  state.account.account_disclaimers.global_zip);
    const { t } = useTranslation();

    return (
        <CalculatorRow
            className = "CalculatorRow__zipCode"
            title = {t(`${isZipCodeUS ? "CustomizePayment.ZipCode.PostalCodeRow.zipCode" : "CustomizePayment.ZipCode.PostalCodeRow.postalCode"}`)}
            tip={globalZipFromAccountDisclaimer}
        >
        <ZipCode
            placeholder={t(`${isZipCodeUS ? "CustomizePayment.ZipCode.PostalCodeRow.zipCode" : "CustomizePayment.ZipCode.PostalCodeRow.postalCode"}`)}
        />
        </CalculatorRow>
    );
}
export default ZipCodeRow;
